import styles from '../Calculator.module.css';

interface Props {
  value: string;
  onChange: (v: string) => void;
  label: string;
  error?: boolean;
  disabled?: boolean;
  max?: number;
  id?: string;
  prefix?: string | null;
}

export function NumberInput({ value, onChange, label, error, disabled, max, id, prefix = '€' }: Props) {
  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const raw = e.target.value.replace(/\D/g, '').replace(/^0+(\d)/, '$1');
    if (max !== undefined && raw !== '' && parseInt(raw, 10) > max) return;
    onChange(raw);
  }

  return (
    <div
      className={[
        styles.numberInputWrapper,
        error ? styles.numberInputError : '',
        disabled ? styles.numberInputDisabled : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className={styles.numberInputInnerContainer}>
        {prefix != null && <span className={styles.numberInputPrefix} aria-hidden="true">{prefix}</span>}
        <input
          id={id}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          value={value}
          onChange={handleChange}
          disabled={disabled}
          className={styles.numberInputField}
          aria-label={label}
        />
      </div>
    </div>
  );
}
